import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api, { formatApiError } from "@/lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);   // null = loading/unknown, false = anon, obj = signed in
  const [initialized, setInitialized] = useState(false);

  const refreshMe = useCallback(async () => {
    const token = localStorage.getItem("argov_token");
    if (!token) {
      setUser(false);
      setInitialized(true);
      return;
    }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      localStorage.setItem("argov_user", JSON.stringify(data));
    } catch {
      setUser(false);
    } finally {
      setInitialized(true);
    }
  }, []);

  useEffect(() => { refreshMe(); }, [refreshMe]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("argov_token", data.access_token);
    localStorage.setItem("argov_user", JSON.stringify(data.user));
    setUser(data.user);
    return data.user;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch { /* ignore */ }
    localStorage.removeItem("argov_token");
    localStorage.removeItem("argov_user");
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, initialized, login, logout, refreshMe, formatApiError }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used within AuthProvider");
  return ctx;
};
